<template>
  <div>{{ $options.name }}</div>
</template>

<script>

export default {
  name: "Admin-Report-Import-Upload",
  path: "upload",
  mounted() {
   this.$spark.$breadcrumbs(this.$options);
  }
};
</script>
